<template>
    <div class="homeWrap">
        <div class="oneCol bgOne">
            <div class="titleItem">
                <div class="oneItemBox">
                    <span class="text">待处理事务</span>
                </div>
            </div>
            <div class="contentItem">
                <div class="oneItemBox link" @click="toPage('/customer/list')">
                    <span class="text">待订货会系统使用审核</span>
                    <span class="num">{{waitOrderingSystemReviewNum}}</span>
                </div>
                <div class="oneItemBox link" @click="toPage('/active/auth')">
                    <span class="text">待活动申请审核</span>
                    <span class="num">{{waitApplicationReviewNum}}</span>
                </div>
            </div>
        </div>
        <div class="oneCol bgTwo">
            <div class="titleItem">
                <div class="oneItemBox">
                    <span class="text">昨日概况</span>
                </div>
            </div>
            <div class="contentItem">
                <div class="oneItemBox">
                    <span class="text">模块申请人数</span>
                    <span class="num">{{yesterdayApplicationOrderingSystemNum}}</span>
                </div>
                <div class="oneItemBox">
                    <span class="text">通过模块申请人数</span>
                    <span class="num">{{yesterdayPassOrderingSystemNum}}</span>
                </div>
                <div class="oneItemBox">
                    <span class="text">申请活动数量</span>
                    <span class="num">{{yesterdayApplicationConferenceNum}}</span>
                </div>
                <div class="oneItemBox">
                    <span class="text">通过活动申请数量</span>
                    <span class="num">{{yesterdayPassConferenceNum}}</span>
                </div>
            </div>
        </div>
        <div class="oneCol bgThree">
            <div class="titleItem">
                <div class="oneItemBox">
                    <span class="text">累计数据</span>
                </div>
            </div>
            <div class="contentItem">
                <div class="oneItemBox">
                    <span class="text">累计模块使用人数</span>
                    <span class="num">{{allUseOrderingSystemNum}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {
        api,
        ajaxPost
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                allUseOrderingSystemNum:'-',
                waitApplicationReviewNum:'-',
                waitOrderingSystemReviewNum:'-',
                yesterdayApplicationConferenceNum:'-',
                yesterdayApplicationOrderingSystemNum:'-',
                yesterdayPassConferenceNum:'-',
                yesterdayPassOrderingSystemNum:'-',
            }
        },
        methods: {
            toPage(url){
                this.$router.push({ path: url, query: { from: 'home' }});
                // this.$router.push(url)
            }
        },
        mounted() {
            let arg = {}
            let _this=this
            ajaxPost('/admin/getHomeInfo', arg).then(function(res) {
                _this.allUseOrderingSystemNum=res.data.allUseOrderingSystemNum
                _this.waitApplicationReviewNum=res.data.waitApplicationReviewNum
                _this.waitOrderingSystemReviewNum=res.data.waitOrderingSystemReviewNum
                _this.yesterdayApplicationConferenceNum=res.data.yesterdayApplicationConferenceNum
                _this.yesterdayApplicationOrderingSystemNum=res.data.yesterdayApplicationOrderingSystemNum
                _this.yesterdayPassConferenceNum=res.data.yesterdayPassConferenceNum
                _this.yesterdayPassOrderingSystemNum=res.data.yesterdayPassOrderingSystemNum
            }, function(res) {

            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .homeWrap {
        display: flex;
        padding-top: 50px;
        padding-left: 50px;
        


        .oneCol {
            width: 280px;

            .oneItemBox {
                border: 1px solid #eee;
                font-size: 16px;
                width: 250px;
                height: 50px;
                line-height: 50px;
                background: blue;
                border-radius: 4px;
                color: #fff;
                text-align: center;
                .text{ margin:0 10px;}
               
            }

            .titleItem {
                height: 72px;

                .oneItemBox {
                    font-weight: bold;
                }
            }

            .contentItem {
                .oneItemBox {
                    margin-bottom: 7px;
                }

                // .oneItemBox:hover {
                //     cursor: pointer;
                //     box-shadow: 0 0 3px darkblue ;
                //     // border: 1px solid darkblue;
                //     border-radius: 4px;
                // }
            }
        }

        .oneCol.bgOne {
            .oneItemBox {
                background: #6A8ABD
            }

            .titleItem {
                .oneItemBox {
                    background: #6A8ABD;
                }
            }
        }

        .oneCol.bgTwo {
            .oneItemBox {
                background: #5AB6DF
            }

            .titleItem {
                .oneItemBox {
                    background: #5AB6DF;
                }
            }
        }

        .oneCol.bgThree {
            .oneItemBox {
                background: #4ACACB
            }

            .titleItem {
                .oneItemBox {
                    background: #4ACACB;
                }
            }
        }
        
        .oneCol .oneItemBox.link:hover{background: darkblue !important;color:lightblue; cursor: pointer;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue